import { AbstractPmsApiService } from './abstract.service';
import { BillingInvoice } from '../models/billing-invoice.model';
import moment from 'moment';

/**
 * @class BillingInvoicePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<BillingInvoice>}
 */
export class BillingInvoicePmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/billing/property/:propertyId/invoices(/:invoiceId)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {BillingInvoice}
     * @protected
     */
    newModel(attributes, ...params) {

        return new BillingInvoice(attributes);
    }

    /**
     * @param {Property} property
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<BillingInvoice>>}
     */
    get(property, params = {}) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    updateDueDate(invoice) {

        const url = this.url({
            propertyId: invoice.property_id,
            invoiceId: invoice.id,
        }) + '/update-due-date';

        const payload = invoice.toObject('due_date');
        payload.due_date = moment(payload.due_date).format('YYYY-MM-DD');

        return this.http
            .post(url, payload, {
                headers: this.authHeaders,
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    openInvoices(subscriptionId, params = {}) {

        const url = this.url({
            subscriptionId: subscriptionId,
        }, '/billing/:subscriptionId') + '/open-invoices';

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }

    getContent(invoice) {

        const url = this.url({
            propertyId: invoice.property_id,
            invoiceId: invoice.id,
        }) + '/return-invoice';

        return this.http
            .get(url, {
                headers: this.authHeaders,
            })
            .then(this.getDataExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/billing-invoice.service.js